import { BridgingHeadsOfTermsController } from "@js/controllers/BridgingHeadsOfTermsController";
import { CommercialHeadsOfTermsController } from "@js/controllers/CommercialHeadsOfTermsController";
import { DevFinanceHeadsOfTermsController } from "@js/controllers/DevFinanceHeadsOfTermsController";
import { BaseService } from "@js/filesfromccqbase/BaseService";
import { BroadcastService } from "@js/filesfromccqbase/BroadcastService";
import {
  BridgingSubmitOfferRequest,
  BridgingSubmitOfferResponse,
  CaseLenderChangedMessageDTO,
  DealLender,
  UserSimpleDTO,
} from "@src/apis/ModularClient";

export class DealLenderService extends BaseService<DealLender, number> {
  static $inject = ["$http", "$cookies", "$rootScope", "$q", "$timeout", "BroadcastService"];

  constructor(
    http: ng.IHttpService,
    cookies: ng.cookies.ICookiesService,
    rootScope: ng.IRootScopeService,
    q: ng.IQService,
    timeout: ng.ITimeoutService,
    broadcastservice: BroadcastService,
  ) {
    super(http, cookies, rootScope, q, timeout, broadcastservice);
    this.$baseAddress = "/api/deallender";
    this.$broadcastBusinessNameSingular = "deallender";
    this.$broadcastBusinessNamePlural = this.$broadcastBusinessNameSingular + "s";
    this.$broadcastScreen = this.$broadcastBusinessNamePlural;
  }

  getRandomIntInclusive(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  dummyDIP(controller) {
    const devFin = controller instanceof DevFinanceHeadsOfTermsController;
    const bridging = controller instanceof BridgingHeadsOfTermsController;
    const commercial = controller instanceof CommercialHeadsOfTermsController;

    if (devFin || bridging) {
      controller.currentCaseLender.totalGrossLoan = this.getRandomIntInclusive(2000, 1000000);
      controller.calculateGrossLoanValVal();
      controller.currentCaseLender.buildLoan = this.getRandomIntInclusive(
        2000,
        controller.currentCaseLender.totalGrossLoan,
      );
      controller.calculateBuildLoadCalcVal();
    }

    if (devFin) {
      controller.currentCaseLender.landLoan = this.getRandomIntInclusive(2000, controller.currentCaseLender.buildLoan);
      controller.calculateLandLoanCalcVal();
    }

    if (commercial) {
      controller.currentCaseLender.totalNetLoan = this.getRandomIntInclusive(1000, 999999);
      controller.currentCaseLender.loanToValue = this.getRandomIntInclusive(0, 100) * 0.01;
      controller.currentCaseLender.lenderArrangementFee = this.getRandomIntInclusive(100, 1000);
      controller.calculatemonetaryLAPercent();
      controller.currentCaseLender.productDuration = this.getRandomIntInclusive(1, 15);
    } else {
      controller.calculateTotalNetLoan();
    }

    if (bridging) {
      controller.currentCaseLender.totalNetLoan = this.getRandomIntInclusive(2000, 999999);
      controller.calculateBorrowerEquity();
    }

    if (devFin || bridging) {
      controller.currentCaseLender.lenderArrangementFee = this.getRandomIntInclusive(100, 1000);
      controller.calculatemonetaryLAPercent();
      controller.calculatemonetaryLAFee();
    }

    if (bridging) {
      controller.currentCaseLender.monthlyInterestRate = this.getRandomIntInclusive(1, 10) * 0.01;
      controller.calculateMonthlyInterestRate();
    }

    controller.currentCaseLender.interestRate = this.getRandomIntInclusive(1, 10) * 0.01;

    if (devFin || bridging) {
      controller.currentCaseLender.interestRateType = this.getRandomIntInclusive(1, 2);
      var types = ["own SVR", "SONIA"];
      controller.currentCaseLender.basisOfInterestRate = types[this.getRandomIntInclusive(0, 1)];
    } else {
      controller.currentCaseLender.monthlyMortgagePayment = this.getRandomIntInclusive(200, 9999);
      controller.currentCaseLender.earlyRepaymentCharge = "Year 1 - 5%";
      controller.currentCaseLender.loanTerm = this.getRandomIntInclusive(
        controller.currentCaseLender.productDuration,
        30,
      );
    }

    if (bridging) {
      controller.currentCaseLender.minimumInterestPeriod = this.getRandomIntInclusive(1, 12);
    }

    if (devFin || bridging) {
      controller.currentCaseLender.lenderExitFee = this.getRandomIntInclusive(100, 5000);
      controller.calculatemonetaryLEPercent();
      controller.calculatemonetaryLEFee();

      controller.calculateTrueCost();
      controller.currentCaseLender.professionalFeesEstimate = this.getRandomIntInclusive(100, 5000);
      controller.currentCaseLender.lenderAdditionalRequirements = "none";
    }

    if (bridging) {
      controller.currentCaseLender.loanTerm = this.getRandomIntInclusive(1, 600);
    }
  }

  convertSecondsToMinuteOrHours(responseTime) {
    if (responseTime > 0) {
        const totalHours = Math.floor(responseTime / 3600);
        const totalMinutes = Math.floor((responseTime % 3600) / 60);

        if (totalHours >= 1) {
            let result = `${totalHours} ${totalHours >= 2 ? "hours" : "hour"}`;

            if (totalMinutes > 0) {
                result += ` and ${totalMinutes} ${totalMinutes >= 2 ? "minutes" : "minute"}`;
            }

            return result;
        } else {
            return `${totalMinutes} ${totalMinutes >= 2 ? "minutes" : "minute"}`;
        }
    } else {
        return "0 minutes";
    }
  }
}
